export default __webpack_public_path__ + "static/img-nhs-optimiser-aa8080bbe14100568d22d19c4214de22.webp";